(() => {
  // node_modules/loadx/dist/loadx.module.js
  var n = function() {
    var n2 = {};
    function r(r2, t, e) {
      return new Promise(function(o, u) {
        if (t === null || !(t instanceof HTMLElement))
          return u(new Error("Parent not found."));
        var c = function(r3) {
          var t2 = JSON.stringify(r3), e2 = n2[t2];
          return e2 !== void 0 ? e2 : null;
        }(e);
        if (c !== null)
          return o(c);
        var i = document.createElement(r2);
        i.onload = function() {
          o(i), function(r3, t2) {
            var e2 = JSON.stringify(r3);
            n2[e2] = t2;
          }(e, i);
        }, i.onerror = function(n3) {
          u(new URIError("The asset " + n3.target.src + " didn't load correctly."));
        }, Object.keys(e).forEach(function(n3) {
          i[n3] = e[n3];
        }), t.appendChild(i);
      });
    }
    return r.js = function(n3) {
      return r("script", document.body, { src: n3 });
    }, r.css = function(n3) {
      return r("link", document.head, { type: "text/css", rel: "stylesheet", href: n3 });
    }, r.img = function(n3, t) {
      return r("img", function(n4) {
        return n4 === void 0 ? document.body : n4;
      }(t), { src: n3 });
    }, r;
  }();

  // src/js/helpers/helpers.js
  function getParentByClassName(from, term) {
    let parent = from.parentElement;
    const search = term;
    let contains = parent.classList.contains(search) ? true : false;
    if (parent != null && !contains) {
      while (!contains) {
        parent = parent.parentElement;
        if (parent != null) {
          contains = parent.classList.contains(search) ? true : false;
          if (contains) {
            return parent;
          }
        }
        if (parent == window.Store.app.theBody) {
          console.warn(`Could not find a match for getParentByClassName('${search}'), returning <body> as a fallback`);
          return window.Store.app.theBody;
        }
      }
    }
    return parent;
  }

  // src/js/components/inputs.js
  var Inputs = class {
    static init() {
      const inputs = window.Store.app.theBody.querySelectorAll(".js-label input, .js-label textarea");
      inputs.forEach((input) => {
        input.addEventListener("focusin", (event) => {
          const parent = getParentByClassName(event.target, "js-label");
          if (parent) {
            parent.classList.add("is-up");
          }
        });
        input.addEventListener("focusout", (event) => {
          Inputs.checkInput(event.target);
        });
        Inputs.checkInput(input);
      });
      Inputs.addGlobalEventListener();
    }
    static checkInput(input) {
      if (!input) {
        return false;
      }
      if (input.tagName.toLowerCase() == "input" || input.tagName.toLowerCase() == "textarea") {
        const parent = getParentByClassName(input, "js-label");
        if (parent) {
          if (input.value.length == 0) {
            parent.classList.remove("is-up");
          } else {
            parent.classList.add("is-up");
          }
        }
      }
    }
    static initCheckAutofill() {
      Inputs.addGlobalEventListener("blur", function(target) {
        window.setTimeout(function() {
          Inputs.checkInput(target);
        }, 20);
      });
    }
    static addGlobalEventListener(eventName, listener) {
      if (!document.body.addEventListener) {
        document.body.attachEvent(eventName, onEvent);
      } else {
        document.body.addEventListener(eventName, onEvent, true);
      }
      function onEvent(event) {
        const target = event.target;
        listener(target);
      }
    }
  };
  function render() {
    Inputs.initCheckAutofill();
    Inputs.init();
  }
  window.Store.components.inputs.render = render;
})();
